import basicController from "servicestack/basic.controller.properties";
import AutoQueryConfig from "servicestack/auto-query/auto-query.config";

export default class AutoQueryTagFilterController {
  constructor() {
    basicController(this);
  }
  $onInit() {
    const $ctrl = this;
    if ($ctrl.hideCheckboxes == undefined)
      $ctrl.hideCheckboxes = AutoQueryConfig.hideCheckboxes === true;
    if ($ctrl.hideEmptyGroupings == undefined)
      $ctrl.hideEmptyGroupings = AutoQueryConfig.hideEmptyGroupings === true;
    if ($ctrl.hideGroupingCounts == undefined)
      $ctrl.hideGroupingCounts = AutoQueryConfig.hideGroupingCounts === true;
    $ctrl.filter.onCleared = () => ($ctrl.selected = false);
  }

  toggle(tag) {
    const $ctrl = this;
    $ctrl.filter.toggle(tag);
    $ctrl.onToggle && $ctrl.onToggle({ tag });
  }
}
